<template>
  <v-dialog
    v-if="showDialog"
    v-model="showDialog"
    max-width="500px"
    @keydown.esc="close"
  >
    <v-card>
      <v-toolbar
        dense
        flat
        color="info"
      >
        <v-toolbar-title class="toolbar-title">
          Request Template: {{ template.name }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <p>
          {{ template.description }}
        </p>
        <p>
          Contact <support-link :subject="`Access to template '${template.name}' (id: ${template.id})`" /> to request access to this template.
        </p>
      </v-card-text>
      <v-card-actions class="pt-3">
        <v-spacer />
        <v-btn
          color="primary"
          outlined
          @click.native="close"
        >
          OK
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import SupportLink from './SupportLink.vue'
export default {
  name: 'TemplatePreviewDialog',
  components: {
    SupportLink
  },
  data() {
    return {
      showDialog: false,
      resolve: null,
      template: null
    }
  },

  methods: {
    open(template) {
      this.template = template
      this.showDialog = true
      return new Promise((resolve) => {
        this.resolve = resolve
      })
    },
    close() {
      this.resolve(true)
      this.showDialog = false
    }
  }
}
</script>
<style lang="scss" scoped>
.toolbar-title {
  color: white
}
</style>
